import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FormBuildService } from './service/form-build.service';
import { FormBaseComponent } from './component/form-base/form-base.component';
import { FormTemplateComponent } from './component/form-template/form-template.component';
import { FormBuildComponent } from './component/form-build/form-build.component';
import { FormChildComponent } from './component/form-child/form-child.component';
import { FormParentComponent } from './component/form-parent/form-parent.component';
import { FormHostDirective } from './directive/form-host.directive';
import { FormWizardComponent } from './component/form-wizard/form-wizard.component';
import { AppComponentModule } from '../../core/component/app-component.module';
import { FormChildDirective } from './directive/form-child.directive';
import { FormFooterComponent } from './component/form-footer/form-footer.component';
import { FormViewDirective } from './directive/form-view.directive';
import { TeleLadaPipe } from './directive/telefono.pipe';
import { TeleLadaDirective } from './directive/telefono.directive';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppComponentModule
  ],
  declarations: [
    FormHostDirective,
    FormChildDirective,
    FormViewDirective,
    FormFooterComponent,
    FormBaseComponent,
    FormTemplateComponent,
    FormBuildComponent,
    FormChildComponent,
    FormParentComponent,
    FormWizardComponent,
    TeleLadaPipe,
    TeleLadaDirective,
  ],
  exports: [
    ReactiveFormsModule,
    FormChildDirective,
    FormViewDirective,
    FormFooterComponent,
    AppComponentModule,
    FormBaseComponent,
    FormTemplateComponent,
    FormChildComponent,
    FormParentComponent,
    FormWizardComponent,
    TeleLadaPipe,
    TeleLadaDirective,
  ],
  providers: [
    TeleLadaPipe,
    FormBuildService,
  ]
})
export class FormCoreModule { }



// WEBPACK FOOTER //
// ./src/app/form/core/form-core.module.ts